<div class="input-group">
    <div class="input-group-btn">
        <button (click)="previousPage($event)"
                aria-label="Zur vorherigen Seite blättern" class="btn {{ applicationStateService.currentViewMode.slug!=='scroll' ? 'btn-outline-secondary' : '' }} arrow-button left" type="button">
            <span class="triangle-left {{applicationStateService.currentIndex <= 0 ? 'triangle-transparent' : '' }}"></span>
        </button>
    </div>
    @if (currentIndices) {
        <input (blur)="onBlur($event)" (change)="changePage($event)" (focus)="onFocus($event)"
               (keydown)="onKeyDown($event)"
               [id]="id" aria-label="Aktuelle Seiten"
               class="form-control"
               type="text"
               value="{{ currentIndices | join:' - ' }}">
    }
    <div class="input-group-btn">
        <button (click)="nextPage($event)"
                aria-label="Zur nächsten Seite blättern" class="btn {{ applicationStateService.currentViewMode.slug!=='scroll' ? 'btn-outline-secondary' : '' }} arrow-button right" type="button">
            <span class="triangle-right {{ applicationStateService.currentIndex + applicationStateService.currentViewMode.pagesToShow >= pageAmount ? 'triangle-transparent' : '' }}"></span>
        </button>
    </div>
</div>